export default __webpack_public_path__ + "24d4bfa2017fd4201496aad254d3cfe6.png";